var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15C4.04444 9.31111 9.03 5 15.0211 5C21.0122 5 25.9967 9.31111 27.0422 15C25.9978 20.6889 21.0122 25 15.0211 25C9.03 25 4.04556 20.6889 3 15V15ZM15.0211 20.5556C16.4945 20.5556 17.9076 19.9702 18.9495 18.9284C19.9914 17.8865 20.5767 16.4734 20.5767 15C20.5767 13.5266 19.9914 12.1135 18.9495 11.0716C17.9076 10.0298 16.4945 9.44444 15.0211 9.44444C13.5477 9.44444 12.1346 10.0298 11.0927 11.0716C10.0509 12.1135 9.46556 13.5266 9.46556 15C9.46556 16.4734 10.0509 17.8865 11.0927 18.9284C12.1346 19.9702 13.5477 20.5556 15.0211 20.5556ZM15.0211 18.3333C14.1371 18.3333 13.2892 17.9821 12.6641 17.357C12.039 16.7319 11.6878 15.8841 11.6878 15C11.6878 14.1159 12.039 13.2681 12.6641 12.643C13.2892 12.0179 14.1371 11.6667 15.0211 11.6667C15.9052 11.6667 16.753 12.0179 17.3781 12.643C18.0033 13.2681 18.3544 14.1159 18.3544 15C18.3544 15.8841 18.0033 16.7319 17.3781 17.357C16.753 17.9821 15.9052 18.3333 15.0211 18.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.3fa216e7f0e7fd498c604244fb1483a2.svg";
export { ForwardRef as ReactComponent };